import { useRecoilValue } from 'recoil';

import { isRevenueReportEnabled } from 'config';
import { PERMISSIONS } from 'constants/Permissions';
import { globalSelectedClinic, loginedUserDetails } from 'store/atoms/authAtom';
import { useHasAccess } from 'utils/hasAccess';

/**
 * Who may open Finance > Revenue. Admins (report:revenue:view:all) always can.
 * Clinic users need a revenue permission and the REVENUE_REPORT flag on the
 * selected clinic group (head clinic).
 */
export const useRevenueReportAccess = () => {
  const loginedUser = useRecoilValue(loginedUserDetails);
  const selectedClinic = useRecoilValue(globalSelectedClinic);
  const canViewAll = useHasAccess(PERMISSIONS.REVENUE_REPORT_VIEW_ALL);
  const canViewOwn = useHasAccess(PERMISSIONS.REVENUE_REPORT_VIEW);
  const canViewClinic = useHasAccess(PERMISSIONS.REVENUE_REPORT_VIEW_CLINIC);
  const isEnabledForClinicGroup = !!loginedUser?.headClinics?.some(
    (clinic) =>
      clinic.value === selectedClinic?.value && clinic.isRevenueReportEnabled
  );
  const canViewAssigned =
    (canViewOwn || canViewClinic) && isEnabledForClinicGroup;
  return {
    canViewAll,
    canViewAssigned,
    /** Also needs the analytics service configured for this environment. */
    canView: isRevenueReportEnabled && (canViewAll || canViewAssigned)
  };
};
